import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @description A VideoCodec class, this class has no methods, and just sets the codec type (vp9, vp8, etc.)
 * @memberOf Qualifiers.VideoCodec
 */

var VideoCodecType = /*#__PURE__*/function (_Qualifier) {
  _inherits(VideoCodecType, _Qualifier);

  var _super = _createSuper(VideoCodecType);

  function VideoCodecType(type) {
    var _this;

    _classCallCheck(this, VideoCodecType);

    _this = _super.call(this, 'vc');
    _this._type = type;

    _this.addValue(type);

    return _this;
  }

  _createClass(VideoCodecType, [{
    key: "getType",
    value: function getType() {
      return this._type;
    }
  }]);

  return VideoCodecType;
}(Qualifier);
/**
 * @description An Advanced VideoCodec class with Profile and Level methods
 * @memberOf Qualifiers.VideoCodec
 */


var AdvVideoCodecType = /*#__PURE__*/function (_Qualifier2) {
  _inherits(AdvVideoCodecType, _Qualifier2);

  var _super2 = _createSuper(AdvVideoCodecType);

  function AdvVideoCodecType(type) {
    var _this2;

    _classCallCheck(this, AdvVideoCodecType);

    _this2 = _super2.call(this, 'vc');
    _this2._type = type;
    return _this2;
  }

  _createClass(AdvVideoCodecType, [{
    key: "getType",
    value: function getType() {
      return this._type;
    }
    /**
     * @description Specifies the profile to use with the h264 codec.
     * @param {Qualifiers.VideoCodecProfile | string} profile Sets the profile of the video codec
     * @example new AdvVideoCodecType('h264').profile(VideoCodecProfile.baseline())
     * @return this;
     */

  }, {
    key: "profile",
    value: function profile(_profile) {
      this._prof = _profile;
      return this;
    }
  }, {
    key: "getProfile",
    value: function getProfile() {
      return this._prof;
    }
    /**
     * @description Specifies the level to use with the h264 codec and specified profile.
     * @param {Qualifiers.VideoCodecLevel | number | string} lvl
     * @example new AdvVideoCodecType('h264').profile(VideoCodecLevel.baseline())
     * @return this;
     */

  }, {
    key: "level",
    value: function level(lvl) {
      this._lvl = lvl;
      return this;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this._lvl;
    }
    /**
     * @description returns a toString representation of this qualifier
     * @return string;
     */

  }, {
    key: "toString",
    value: function toString() {
      return "vc_".concat(this._type, ":").concat(this._prof, ":").concat(this._lvl);
    }
  }]);

  return AdvVideoCodecType;
}(Qualifier);

export { VideoCodecType, AdvVideoCodecType };